import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntakes } from '../../hooks/useIntakes';
import IntakeForm from '../../components/forms/IntakeForm';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const IntakeNew = () => {
  const navigate = useNavigate();
  const { addIntake } = useIntakes();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const result = await addIntake(formData);
      if (result.success) {
        alert('Intake created successfully!');
        navigate('/intakes');
      } else {
        alert(result.error || 'Failed to create intake');
      }
    } catch (error) {
      alert('An unexpected error occurred');
      console.error('Error creating intake:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/intakes');
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <Button 
          variant="outline" 
          onClick={handleCancel}
          className="flex items-center"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-1" />
          Back
        </Button>
        <h1 className="text-xl font-bold text-gray-900">Add New Intake</h1>
      </div>
      
      <Card>
        <IntakeForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default IntakeNew;